const Footer = () => {
  return (
    <footer data-testid="footer" className="relative border-t border-white/[0.06] bg-[#040404]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-[1.2fr_1fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2">
              <div className="relative h-6 w-6">
                <div className="absolute inset-0 rounded-md bg-gradient-to-br from-indigo-500 to-violet-600" />
                <div className="absolute inset-[3px] rounded-[4px] bg-[#040404] flex items-center justify-center">
                  <div className="h-[2px] w-2.5 bg-indigo-400" />
                </div>
              </div>
              <span className="font-display text-[15px] font-semibold tracking-tight text-white">
                Equal
              </span>
              <span className="hidden sm:inline-flex items-center rounded-full border border-white/10 bg-white/[0.03] px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.2em] text-zinc-500">
                EqualLayer
              </span>
            </div>
            <p className="mt-5 font-body text-sm text-zinc-500 max-w-xs leading-relaxed">
              Equal is building EqualLayer — an intelligent interaction layer for the web. Accessibility
              first. Designed for everyone.
            </p>
          </div>

          {[
            {
              title: "Product",
              links: [
                { label: "Problem", href: "#problem" },
                { label: "Solution", href: "#solution" },
                { label: "How it works", href: "#how" },
              ],
            },
            {
              title: "Mission",
              links: [
                { label: "Accessibility", href: "#accessibility" },
                { label: "Vision", href: "#vision" },
                { label: "Join waitlist", href: "#waitlist" },
              ],
            },
            {
              title: "Company",
              links: [
                { label: "Contact", href: "mailto:hello@equallayer.app" },
                { label: "Privacy", href: "/privacy" },
                { label: "Terms", href: "/terms" },
              ],
            },
          ].map((col, i) => (
            <div key={i}>
              <div className="font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-500">
                {col.title}
              </div>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l, j) => (
                  <li key={j}>
                    <a
                      href={l.href}
                      className="font-body text-sm text-zinc-300 hover:text-white transition-colors"
                      data-testid={`footer-link-${col.title.toLowerCase()}-${j}`}
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t border-white/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-500">
            © {new Date().getFullYear()} EqualLayer · All rights reserved
          </div>
          <div className="font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-500 flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.7)]" />
            Systems operational · v0.1
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
